import React, { FC } from 'react';
import GeneralInformationsCard from './GeneralInformationsCard';
import Ticket from 'src/interfaces/api/Ticket';
import useTicket from 'src/hooks/api/useTicket';
import { useSetRecoilState } from 'recoil';
import { ticketState as recoilTicketState } from 'src/recoil/selectors/tickets';

interface Props {
  ticket: Ticket;
}

const GeneralInformationsCardContainer: FC<Props> = ({ ticket, ...props }) => {
  const setTicket = useSetRecoilState(recoilTicketState(ticket.id));
  const { update } = useTicket();

  const handleUpdateField = async <T extends keyof Ticket>(fieldName: T, newValue: Ticket[T]) => {
    if (ticket) {
      const newTicket = await update(ticket.id, { [fieldName]: newValue });
      setTicket(newTicket);
    }
  };

  return <GeneralInformationsCard ticket={ticket} onUpdateField={handleUpdateField} {...props} />;
};

export default GeneralInformationsCardContainer;
